import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import ShareLine from './shareLine';
// import ArticleStore from './article.store';
import TrackVisibility from 'react-on-screen';
import ArticleStore from '../article/article.store';
import ShareLineStore from './shareLine.store';
import {showStat} from './shareLine.stat';

interface IContainerProps {
  className?: string;
  style?: CSSProperties;
}
interface IContainerInjectProps extends IContainerProps {
  shareLineStore: ShareLineStore;
}

interface IContainerState {}

const stats = {

};

export default class Container extends Component<IContainerProps, IContainerState> {
  constructor(props) {
    super(props);
  }

  public get injected() {
    return this.props as IContainerInjectProps;
  }

  public render() {
    const shareLineStore: ShareLineStore = this.injected.shareLineStore;
    // console.log('Container shareLineStore', shareLineStore);
    const articleStore = shareLineStore ? shareLineStore.root.articleStore as ArticleStore : null;

    return (
      <TrackVisibility partialVisibility once>
        {({ isVisible }) => {
          console.log('shareLine isVisible', isVisible);
          if (isVisible) {
            showStat();
          }
          return <ShareLine story={articleStore.story.raw_item} country={shareLineStore.country}></ShareLine>
          ;
        }}

      </TrackVisibility>
    );
  }
}
